import React, { Component, createContext } from 'react';
import axios from 'axios';
import MoonLoader from 'react-spinners/MoonLoader';
import Methods from '../ApiCalls/apiMethods';
import { useAPI } from '../ApiCalls/useAPI';

export const MyContext = createContext();

// Define the base URL
const Axios = axios.create({
    baseURL: Methods.global_url + '/sanjaya/auth/'
});

class MyContextProvider extends Component {
    constructor() {
        super();
        this.state = {
            isAuth: false,
            theUser: null,
            first_login: false
        };
    }

    componentDidMount() {
        const loginToken = localStorage.getItem('loginToken');
        if (loginToken) {
            this.setState({
                loading: true
            });
            this.getUserInfo(loginToken).then((data) => {
                if (data && data.success) {
                    const { getProfile } = useAPI();
                    getProfile().then((response) =>
                        response.newlogin === '1'
                            ? this.setState({ first_login: true })
                            : this.setState({ first_login: false })
                    );
                    this.setState({
                        isAuth: true,
                        theUser: data.user,
                        loading: false
                    });
                } else {
                    this.setState({
                        loading: false,
                        isAuth: false
                    });
                }
            });
        }
    }

    // On Click the Log out button
    logoutUser = () => {
        localStorage.clear();
        this.setState({
            ...this.state,
            isAuth: false
        });
    };

    loginUser = async (user) => {
        const result = {
            success: false
        };
        const login = await Axios.post('login.php', {
            mobilenumber: user.mobilenumber,
            password: user.password
        });
        if (login.data.success) {
            const { token } = login.data;
            localStorage.setItem('loginToken', token);
            const userData = await this.getUserInfo(token);

            if (userData && userData.success) {
                const { getProfile } = useAPI();
                getProfile().then((response) =>
                    response.newlogin === '1'
                        ? this.setState({ first_login: true })
                        : this.setState({ first_login: false })
                );
                this.setState({
                    isAuth: true,
                    theUser: userData.user
                });
                result.success = true;
            } else {
                result.error = 'Failed to fetch user info';
            }
        } else {
            this.setState({
                isAuth: false
            });
            result.error = 'Failed to fetch login token';
        }

        return result;
    };

    getUserInfo = async (loginToken) => {
        const login = {
            success: false
        };
        Axios.defaults.headers.common['Authorization'] = 'bearer ' + loginToken;
        const { data } = await Axios.get('user-info.php');
        // console.log(data, 'rollno');
        if (data.success) {            
            localStorage.setItem('rollno', data.user.rollno);
            localStorage.setItem('psflag', data.user.psflag);
            login.success = true;
        } else {
            login.error = 'Failed to fetch user info';
            this.setState({
                loading: false
            });
        }
        return data;
    };

    render() {
        const contextValue = {
            rootState: this.state,
            getUserInfo: this.getUserInfo,
            // userInfo : this.state.userInfo,
            isLoggedIn: this.state.isAuth,
            loginUser: this.loginUser,
            logoutUser: this.logoutUser,
            first_login: this.state.first_login
        };
        const override = `
            display: block;
            margin: 10% auto;
            border-color: red;
        `;
        if (this.state.loading) {
            return (
                <div>
                    <h1 className="mt-4" style={{ textAlign: 'center' }}>
                        Loading ...
                    </h1>
                    <MoonLoader
                        color={'green'}
                        isLoading={true}
                        css={override}
                        size={60}
                    />
                </div>
            );
        }

        return (
            <MyContext.Provider value={contextValue}>
                {this.props.children}
            </MyContext.Provider>
        );
    }
}

export default MyContextProvider;
